module.exports = __webpack_public_path__ + "static/media/circle-info.d836b61e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/circle-info.svg
// module id = 632
// module chunks = 0